"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserMapLocationPin = void 0;
const react_1 = __importDefault(require("react"));
const components_core_1 = require("@volkswagen-onehub/components-core");
const UserMapLocationContainer = components_core_1.styled.div `
  .svg-area {
    display: block;
  }

  #radar {
    animation: pulse 2s infinite;
  }
  @keyframes pulse {
    from {
      transform: translate(50%, 50%) scale(0);
      opacity: 1;
    }
    to {
      transform: translate(50%, 50%) scale(1);
      opacity: 0;
    }
  }
`;
const UserMapLocationPin = () => (react_1.default.createElement(UserMapLocationContainer, null,
    react_1.default.createElement("svg", { className: "svg-area", width: "44px", height: "44px", viewBox: "0 0 44 44", xmlns: "http://www.w3.org/2000/svg", fill: "#001e50" },
        react_1.default.createElement("circle", { id: "radar", r: "22" }),
        react_1.default.createElement("circle", { id: "core", cx: "22", cy: "22", r: "4.539" }))));
exports.UserMapLocationPin = UserMapLocationPin;
